export enum AssetStatus {
  Live = 'live',
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  Expired = 'expired',
  Inactive = 'inactive',
}
